import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class Spinner extends AbstractProvidedClass {
    create(x, y, size, color = null, width = null, height = null) {
        this.active = true

        this.x = x;
        this.y = y;
        this.size = size;
        this.color = color;
        this.width = width;
        this.height = height;
        this.pos = 0;
    }

    reset() {
        this.active = false;
    }

    display() {
        if (!this.active) {
            return;
        }

        this.p.noStroke();
        this.p.push()
        this.pos += 0.08;
        this.p.translate(this.x, this.y);
        if (this.width) {
            this.p.rectMode(this.p.CENTER);
            this.p.fill(this.color ?? 255);
            this.p.rect(0, 0, this.width, this.height ?? this.width);
        }
        this.p.rotate(this.pos);
        this.p.fill(0);
        this.p.arc(0, 0, this.size, this.size, 0, this.p.PI + this.p.HALF_PI);
        this.p.fill(this.color ?? 255);
        this.p.circle(0, 0, this.size * 3 / 4);
        this.p.pop();
    }
}
